<template>
  <BaseWidget :activeTabIndex="tabIndex" :tabs="tabs"></BaseWidget>
</template>

<script lang="ts" setup>
import BaseWidget from "@/components/BaseWidget.vue";
import { ref } from "vue";
import { QuickformTab } from "../models/QuickformTab";
import RoundTrip from "./RoundTrip.vue";
import OneWay from "./OneWay.vue";
import MultiLeg from "./MultiLeg.vue";

const tabs: QuickformTab[] = [];

const tabIndex = ref(0);

tabs.push({
  component: RoundTrip,
  code: "RoundTrip",
  label: "Round Trip",
});

tabs.push({
  component: OneWay,
  code: "OneWay",
  label: "One Way",
});

tabs.push({
  component: MultiLeg,
  code: "MultiLeg",
  label: "Multi Leg",
});
</script>

<style lang="scss" scoped>
* {
  font-family: "Source Sans Pro", Helvetica, sans-serif;
}
</style>
